class HtmlControlComponent {
	
	constructor(height) {
		this.height = height;
	}
	
	async init(element, className, style) {		
		const { init } = await import(/* webpackChunkName: "tinymce" */ './tinymce_editor');
				
		this.editor = await init({
			element: element, 
			className: className, 
			style: style,
			height: this.height
		});
        
        if( this.editor && this.pendingValue ) {
        	this.editor.setContent(this.pendingValue);
        	this.pendingValue = null;   
        }
	}	
	
	setValue(value) {
		if( this.editor ) {
			this.editor.setValue(value);			
		} else {
			this.pendingValue = value;
		}
    }
	
	getValue() {
		if( this.editor ) {
			return this.editor.getValue();
		} else {
			return this.pendingValue;
		}
	}
	
	destroy() {
		if( this.editor ) {
			this.editor.destroy();
			this.editor = null;
		}
	}
}

const HTMLTextArea = (width) => {
	return new HtmlControlComponent(width);
};

export {
	HTMLTextArea
}